import { DOCUMENT } from '@angular/common';
import { Injectable, RendererFactory2, inject } from '@angular/core';

const FV_PAGE_CONTENT_PADDING_BOTTOM_CSS_VAR_NAME = '--fv-page-content-padding-bottom';
const FV_BOTTOM_ACTIONS_BAR_HEIGHT_CSS_VAR_NAME = '--fv-bottom-actions-bar-height';

@Injectable({
  providedIn: 'root',
})
export class FinLayoutService {
  private readonly document = inject(DOCUMENT);
  private readonly defaultPageContentPaddingBottom: string;
  private readonly rendererFactory2 = inject(RendererFactory2);
  private readonly renderer = this.rendererFactory2.createRenderer(null, null);

  constructor() {
    this.defaultPageContentPaddingBottom = getComputedStyle(this.document.documentElement)
      .getPropertyValue(FV_PAGE_CONTENT_PADDING_BOTTOM_CSS_VAR_NAME)
      .trim();
  }

  setAuthLayoutBackgroundColor(): void {
    this.renderer.addClass(this.document.body, 'auth-layout-background');
  }

  removeAuthLayoutBackgroundColor(): void {
    this.renderer.removeClass(this.document.body, 'auth-layout-background');
  }

  addPageContentPaddingBottom(additionalPaddingRem: number): void {
    // Compose with calc() rather than parsing a number out of the default and re-emitting it as rem:
    // the default is a design token whose unit is not ours to assume — it moved from `2rem` to
    // `var(--fv-spacing-2xl)` (= 32px), which made `parseFloat` + a `rem` suffix resolve 32px to
    // 37.75rem (604px) of dead space below the page content.
    this.document.documentElement.style.setProperty(
      FV_PAGE_CONTENT_PADDING_BOTTOM_CSS_VAR_NAME,
      `calc(${this.defaultPageContentPaddingBottom || '0px'} + ${additionalPaddingRem}rem)`
    );
    this.document.documentElement.style.setProperty(
      FV_BOTTOM_ACTIONS_BAR_HEIGHT_CSS_VAR_NAME,
      `${additionalPaddingRem}rem`
    );
  }

  resetPageContentPaddingBottom(): void {
    this.document.documentElement.style.setProperty(
      FV_PAGE_CONTENT_PADDING_BOTTOM_CSS_VAR_NAME,
      this.defaultPageContentPaddingBottom
    );
    this.document.documentElement.style.setProperty(FV_BOTTOM_ACTIONS_BAR_HEIGHT_CSS_VAR_NAME, '0px');
  }
}
